import axios from 'axios'

export default class IniciativaAderida {
  constructor (tokenBearer, url, id) {
    this.url = `${url}/api/unimed/iniciativa`
    this.id = id
    this.tokenBearer = tokenBearer
  }

  getIniciativas () {
    return new Promise(async (resolve, reject) => {
      let optionsIniciativas = {
        method: 'get',
        url: `${this.url}/${this.id}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseIniciativas = await axios(optionsIniciativas)
        resolve(responseIniciativas)
      } catch (err) {
        reject(err)
      }
    })
  }

  putIniciativas (data) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url: `${this.url}/${this.id}`,
        headers: {
          'Authorization': this.tokenBearer
        },
        data
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
